<template>
  <div class="moduleTutorialWrap">
    <div class="content">
      <p class="title">{{ $t('lang.k_357001') }}</p>
      <div class="content-container">
        <article class="valueItem">
          <p class="itemTitle"></p>
          <p class="itemValue">{{ $t('lang.k_357002') }}</p>
        </article>
        <article class="valueItem">
          <p class="itemTitle"></p>
          <p class="itemValue">
            <span style="display: block; font-weight: bold">{{ $t('lang.k_357003') }}</span>
            {{ $t('lang.k_357004') }}
          </p>
        </article>
      </div>
    </div>
  </div>
</template>

<script>
  export default {};
</script>

<style lang="less" scoped>
  .moduleTutorialWrap {
    background-image: url('../../../common/images/introduce.png');
    background-size: cover;
    height: 500px;
    margin-top: -40px;
  }
  .content {
    padding: 146px 0 0 445px;

    .title {
      min-width: 95px;
      height: 24px;
      background: #fb3d32;
      border-radius: 12px;
      color: #ffffff;
      line-height: 24px;
      font-size: 16px;
      text-align: center;
      display: inline-block;
      padding: 0 10px;
    }

    .content-container {
      position: absolute;
      top: 190px;
      width: 230px;
      bottom: 20px;
      overflow: auto;
      overflow-x: hidden;
      pointer-events: initial;
      white-space: normal;
      word-break: break-word;
      overflow-wrap: break-word;
    }

    .valueItem {
      .itemTitle {
        width: 33px;
        height: 3px;
        margin-top: 22px;
        // background-image: linear-gradient(to right, color-stop1, color-stop2);

        background: linear-gradient(270deg, rgba(255, 255, 255, 0.2) 0%, #fb3b32 100%);
      }
      .itemValue {
        width: 230px;
        padding-top: 10px;
        font-size: 14px;
        font-weight: 400;
        color: #1a1a1a;
        line-height: 20px;
      }
    }
  }
</style>
